import type { TFunction } from 'i18next';
import U2000DeleteRecordDialog from '../../../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import type { U3202OrgModelConfigHandler } from './U3202OrgModelConfigHandlers';

interface U3202CatalogModelDeleteDlgProps {
  handler: U3202OrgModelConfigHandler;
  t: TFunction;
  NS: string;
}

function U3202CatalogModelDeleteDlg({ handler, t, NS }: U3202CatalogModelDeleteDlgProps) {
  if (!handler.isDeleteDialogOpen) {
    return null;
  }

  const selectedRows = handler.gridStateHandlers.getSelectedRows();

  return (
    <U2000DeleteRecordDialog
      isOpen={handler.isDeleteDialogOpen}
      onClose={handler.onDlgDeleteClose}
      title={t('lblDeleteDlgTitle', { ns: NS })}
    >
      <p className="mb-4">
        {t('catalogModel.deleteConfirm', {
          count: selectedRows.length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {selectedRows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800 dark:text-gray-200">
            {row.modelName} ({row.modelCode})
            {index < array.length - 1 ? ', ' : ''}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3202CatalogModelDeleteDlg;
